import { Pages } from "@constants/pages/Pages";
import { ModuleType } from "@enums/ModuleType";
import { GetIconByModuleString } from "@methods/Icons";
import { ApplicationPermissionsModel } from "@models/permissions/ApplicationPermissionsModel";
import { DashboardQuickLinkModel } from "../../../shared/models/DashboardQuickLinkModel";
import { ILinkWidgetGeneratorType } from "./../../../shared/interfaces/ILinkWidgetGeneratorType";
import { ModuleSubType } from "@enums/ModuleSubType";
import { MicroservicePermissionService } from "@services/permissions/permissions.service";
import { MicroserviceModule } from "@enums/microservice-module.enum";

export class ModuleOverviewLinkGenerator implements ILinkWidgetGeneratorType {
    constructor(private microservicePermissionService: MicroservicePermissionService) {}

    getTypes(permissions: ApplicationPermissionsModel, pages: Pages): DashboardQuickLinkModel[] {
        const quickLinks = [];
        if (permissions.HasRiskAccess) {
            quickLinks.push({
                title: "linkWidget.riskOverviewTitle",
                icon: GetIconByModuleString(ModuleType.ORMDescription),
                page: pages.RiskOverview,

                description: "linkWidget.riskOverviewDescription",
            });
        }

        if (permissions.HasControlAccess) {
            quickLinks.push({
                title: "linkWidget.controlOverviewTitle",
                icon: GetIconByModuleString(ModuleType.ControlsDescription),
                page: pages.ControlOverview,

                description: "linkWidget.controlOverviewDescription",
            });
        }

        if (permissions.HasAdvancedTestingAccess) {
            quickLinks.push({
                title: "linkWidget.advEffOverviewTitle",
                icon: GetIconByModuleString(ModuleSubType.AdvEffTestingDescription),
                page: pages.ControlsTestingAdvEffOverview,

                description: "linkWidget.advEffOverviewDescription",
            });
        }

        if (permissions.HasTaskAccess) {
            quickLinks.push({
                title: "linkWidget.taskOverviewTitle",
                icon: GetIconByModuleString(ModuleType.TasksDescription),
                page: pages.TaskOverview,

                description: "linkWidget.taskOverviewDescription",
            });
        }

        if (permissions.HasEventAccess) {
            quickLinks.push({
                title: "linkWidget.eventOverviewTitle",
                icon: GetIconByModuleString(ModuleType.LERDescription),
                page: pages.EventOverview,

                description: "linkWidget.eventOverviewDescription",
            });
        }

        if (
            permissions.HasIncidentAccess &&
            this.microservicePermissionService.hasModuleAccess(MicroserviceModule.Incidents)
        ) {
            quickLinks.push({
                title: "linkWidget.incidentOverviewTitle",
                icon: GetIconByModuleString(ModuleType.IncidentsDescription),
                page: pages.IncidentOverview,

                description: "linkWidget.incidentOverviewDescription",
            });
        }

        if (permissions.HasFindingReportAccess) {
            quickLinks.push({
                title: "linkWidget.findingReportTitle",
                icon: GetIconByModuleString(ModuleType.FRDescription),
                page: pages.ImOverview,

                description: "linkWidget.findingReportDescription",
            });
        }

        if (permissions.HasMoiAccess) {
            quickLinks.push({
                title: "linkWidget.moisTitle", // ModuleType.BIMDescription,
                icon: GetIconByModuleString(ModuleType.BIMDescription),
                page: pages.MoiOverview,

                description: "linkWidget.moisDescription",
            });
        }

        if (permissions.HasKriAccess) {
            quickLinks.push({
                title: "linkWidget.kriOverviewTitle",
                icon: GetIconByModuleString(ModuleType.KRIDescription),
                page: pages.KriOverview,

                description: "linkWidget.kriOverviewDescription",
            });
        }

        if (permissions.HasDataManagementAccess) {
            quickLinks.push({
                title: "linkWidget.dataManagementTitle",
                icon: GetIconByModuleString(ModuleType.DMDescription),
                page: pages.DataManagementOverview,

                description: "linkWidget.dataManagementDescription",
            });
        }

        if (permissions.HasThirdPartyAccess) {
            quickLinks.push({
                title: "linkWidget.thirdPartyTitle",
                icon: GetIconByModuleString(ModuleType.TPDescription),
                page: pages.Thirdparty,

                description: "linkWidget.thirdPartyDescription",
            });
        }

        //if (permissions.HasAssetManagementAccess) {
        if (permissions.HasAssetManagementAccess) {
            quickLinks.push({
                title: "linkWidget.assetManagementTitle",
                icon: GetIconByModuleString(ModuleType.AssetManagementDescription),
                page: pages.AssetManagementOverview,

                description: "linkWidget.assetManagementDescription",
            });
        }

        if (permissions.Forms.HasAccess) {
            quickLinks.push({
                title: "linkWidget.formsTitle",
                icon: GetIconByModuleString(ModuleType.FRMDescription),
                page: pages.Forms,

                description: "linkWidget.formsDescription",
            });
        }

        return quickLinks;
    }
}
